export const isProfileSpec = (spec) => spec.dataLayerId !== undefined &&
    spec.label !== undefined;
/*
  Site Profile Specs
*/
// <DataInsightsPanel>
export const conditionsTabProfile = {
    // <SiteCard>
    landCover: {
        dataLayerId: 'data-layer-land-cover-en',
        queryType: 'raster',
        queryLayer: 'la-impervious-surface',
        aggregationMethod: 'categoricalPercentage',
        label: {
            'en-us': 'Land Cover',
            'es-mx': 'Cubierta terrestre'
        }
    },
    // <StormwaterSection>
    annualRainfall: {
        dataLayerId: '40630c55-8bb8-4a52-8b3c-7c1e6f42dde8',
        queryType: 'raster',
        queryLayer: 'annual-rainfall',
        aggregationMethod: 'volumeOverAreas',
        label: {
            'en-us': 'Rainfall',
            'es-mx': 'Precipitación'
        },
        singularUnits: {
            'en-us': 'Gallon',
            'es-mx': 'Galón'
        },
        pluralUnits: {
            'en-us': 'Gallons',
            'es-mx': 'Galones'
        }
    },
    stormEventRainfall: {
        dataLayerId: 'data-layer-precipitation-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-storm-event',
        attributes: ['rainfall'],
        aggregationMethod: 'volumeOverAreas',
        label: {
            'en-us': 'Rainfall',
            'es-mx': 'Precipitación'
        }
    },
    rainfallRunoffTotal: {
        dataLayerId: '9fc75e8f-35f4-46d1-8923-6d9cf4cecc25',
        queryType: 'raster',
        includeBufferedArea: true,
        queryLayer: 'la-runoff-contribution-areas-total',
        aggregationMethod: 'max',
        label: {
            'en-us': 'Contribution Area',
            'es-mx': 'Área de Contribución'
        },
        singularUnits: {
            'en-us': 'acre',
            'es-mx': 'acre'
        },
        pluralUnits: {
            'en-us': 'acres',
            'es-mx': 'acres'
        }
    },
    rainfallRunoffImpervious: {
        dataLayerId: '9fc75e8f-35f4-46d1-8923-6d9cf4cecc25',
        queryType: 'raster',
        includeBufferedArea: true,
        queryLayer: 'la-runoff-contribution-areas-impervious',
        aggregationMethod: 'max',
        label: {
            'en-us': 'impervious',
            'es-mx': 'impermeable'
        },
        singularUnits: {
            'en-us': 'acre',
            'es-mx': 'acre'
        },
        pluralUnits: {
            'en-us': 'acres',
            'es-mx': 'acres'
        }
    },
    rainfallRunoffPervious: {
        dataLayerId: '9fc75e8f-35f4-46d1-8923-6d9cf4cecc25',
        queryType: 'raster',
        includeBufferedArea: true,
        queryLayer: 'la-runoff-contribution-areas-pervious',
        aggregationMethod: 'max',
        label: {
            'en-us': 'pervious',
            'es-mx': 'permeable'
        },
        singularUnits: {
            'en-us': 'acre',
            'es-mx': 'acre'
        },
        pluralUnits: {
            'en-us': 'acres',
            'es-mx': 'acres'
        }
    },
    groundwaterBasin: {
        dataLayerId: 'f07f4e41-8c37-4139-b710-32af0de2b529',
        queryType: 'featureProperties',
        queryLayer: 'groundwater-basins',
        attributes: ['basin_name'],
        aggregationMethod: 'uniqueList',
        label: {
            'en-us': 'Groundwater Basin',
            'es-mx': 'Cuenca de agua subterránea'
        }
    },
    infiltration: {
        // only show card if groundwaterBasins.length > 0
        dataLayerId: '401fa35c-af57-4ef8-99dd-0fad2ffa948f',
        queryType: 'raster',
        queryLayer: 'infiltration',
        aggregationMethod: 'mean',
        label: {
            'en-us': 'Infiltration',
            'es-mx': 'Infiltración'
        },
        singularUnits: {
            'en-us': 'inch per hour',
            'es-mx': 'pulgada por hora'
        },
        pluralUnits: {
            'en-us': 'inches per hour',
            'es-mx': 'pulgadas por hora'
        }
    }
};
// <SiteInformationPanel>
export const detailsTabProfile = {
    // Site table
    roofCover: {
        dataLayerId: 'data-layer-roofs-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-roofs-v2',
        aggregationMethod: 'totalFeatureArea',
        label: {
            'en-us': 'Roof Cover',
            'es-mx': 'Cubierta del tejado'
        }
    },
    landOwnership: {
        dataLayerId: 'data-layer-parcels-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-parcels',
        attributes: ['agency_name'],
        aggregationMethod: 'uniqueList',
        defaultAttributeValue: 'Private',
        label: {
            'en-us': 'Land Ownership',
            'es-mx': 'Titularidad del terreno'
        }
    },
    // Land Use card
    landUse: {
        dataLayerId: 'data-layer-parcels-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-parcels',
        attributes: ['land_use_type'],
        aggregationMethod: 'categoricalPercentage',
        label: {
            'en-us': 'Land Use',
            'es-mx': 'Uso de tierra'
        }
    },
    parcelNumbers: {
        // only for exports
        dataLayerId: 'data-layer-parcels-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-parcels',
        attributes: ['ain'],
        aggregationMethod: 'uniqueList',
        label: {
            'en-us': 'Assessor Parcel Numbers',
            'es-mx': 'Números de Parcela del Evaluador'
        }
    },
    // Policy Details cards
    disadvantagedCommunity: {
        dataLayerId: 'data-layer-disadvantaged-communities-en',
        queryType: 'featureProperties',
        queryLayer: 'disadvantaged-communities',
        aggregationMethod: 'count',
        label: {
            'en-us': 'Disadvantaged Community',
            'es-mx': 'Comunidad desfavorecida'
        },
        singularUnits: {
            'en-us': 'Using CalEPA SB 535 designation',
            'es-mx': 'Usando la designación CalEPA SB 535'
        }
    },
    disadvantagedCommunityBuffer: {
        dataLayerId: 'data-layer-disadvantaged-communities-en',
        queryType: 'featureProperties',
        queryLayer: 'disadvantaged-communities',
        includeBufferedArea: true,
        aggregationMethod: 'count',
        label: {
            'en-us': 'Within site walkshed',
            'es-mx': 'Dentro de la zona de caminata del sitio'
        }
    },
    calenviroscreen: {
        dataLayerId: 'data-layer-calenviroscreen-en',
        queryType: 'featureGeojson',
        queryLayer: 'ca-calenviroscreen',
        attributes: ['calenviroscreen_score_percentile'],
        aggregationMethod: 'weightedAverage',
        label: {
            'en-us': 'CalEnviroScreen Score',
            'es-mx': 'Puntuación de CalEnviroScreen'
        },
        singularUnits: {
            'en-us': 'percentile',
            'es-mx': 'percentil'
        }
    },
    existingProjects: {
        dataLayerId: 'data-layer-existing-projects-en',
        queryType: 'featureProperties',
        queryLayer: 'la-existing-projects',
        includeBufferedArea: true,
        aggregationMethod: 'count',
        label: {
            'en-us': 'Existing Projects',
            'es-mx': 'Proyectos existentes'
        },
        singularUnits: {
            'en-us': 'in walkshed',
            'es-mx': 'en área de caminata'
        }
    },
    // Location cards
    municipalities: {
        dataLayerId: 'data-layer-municipalities-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-municipalities',
        attributes: ['name'],
        aggregationMethod: 'uniqueList',
        label: {
            'en-us': 'Municipality',
            'es-mx': 'Municipio'
        }
    },
    supervisorialDistricts: {
        dataLayerId: 'data-layer-supervisorial-districts-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-supervisorial-districts',
        attributes: ['name'],
        aggregationMethod: 'uniqueList',
        label: {
            'en-us': 'Supervisorial District',
            'es-mx': 'Distrito de supervisión'
        }
    },
    censusTracts: {
        dataLayerId: 'data-layer-census-tracts-en',
        queryType: 'featureProperties',
        queryLayer: 'us-census-tracts',
        attributes: ['fips'],
        aggregationMethod: 'uniqueList',
        label: {
            'en-us': 'Census Tract',
            'es-mx': 'Zona censal'
        }
    },
    neighborhoods: {
        dataLayerId: 'data-layer-neighborhoods-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-neighborhoods',
        attributes: ['name'],
        aggregationMethod: 'uniqueList',
        label: {
            'en-us': 'Neighborhood',
            'es-mx': 'Vecindario'
        }
    },
    scwpWatershedArea: {
        dataLayerId: '4f6f4134-4fd1-49d8-8d26-89de54d5f469',
        queryType: 'featureProperties',
        queryLayer: 'la-watershed-scwp-areas',
        attributes: ['name'],
        aggregationMethod: 'uniqueList',
        label: {
            'en-us': 'SCWP Watershed Area',
            'es-mx': 'Área de cuenca de SCWP'
        }
    },
    hydrologicWatershed: {
        dataLayerId: '9fda414a-b594-4b41-9498-30c3528befc6',
        queryType: 'featureProperties',
        queryLayer: 'watersheds-huc-12',
        attributes: ['watershed_name', 'name'],
        aggregationMethod: 'uniqueList',
        label: {
            'en-us': 'Hydrologic Watershed',
            'es-mx': 'Cuenca Hidrológica'
        }
    },
    subwatershed: {
        dataLayerId: 'bb9da9e3-379e-4c76-9799-f93751408858',
        queryType: 'featureProperties',
        queryLayer: 'la-watershed-sub-watershed',
        attributes: ['name', 'id', 'name2', 'watershed'],
        aggregationMethod: 'uniqueList',
        label: {
            'en-us': 'Subwatershed',
            'es-mx': 'Subcuenca'
        }
    },
    historicHabitat: {
        dataLayerId: 'data-layer-historic-habitats-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-historic-habitats',
        attributes: ['habitat_type'],
        aggregationMethod: 'uniqueList',
        label: {
            'en-us': 'Historical Habitat',
            'es-mx': 'Hábitat histórico'
        }
    },
    tribalArea: {
        dataLayerId: 'data-layer-tribal-areas-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-tribal-areas',
        attributes: ['name'],
        aggregationMethod: 'uniqueList',
        label: {
            'en-us': 'Indigenous Territories',
            'es-mx': 'Territorios Indígenas'
        }
    }
};
// <OpportunitiesSection>
export const benefitsMetadata = {
    'effect-air-quality': {
        queryType: 'featureGeojson',
        queryLayer: 'air-pollution-exposure',
        attributes: ['air_pollution_exposure'],
        aggregationMethod: 'weightedAverage',
        singularUnits: {
            'en-us': 'percentile air pollution exposure',
            'es-mx': 'exposición percentil a la contaminación del aire'
        },
        pluralUnits: {
            'en-us': 'percentile air pollution exposure',
            'es-mx': 'exposición percentil a la contaminación del aire'
        },
        higherIsBetter: false
    },
    'effect-biodiversity': {
        queryType: 'raster',
        queryLayer: 'habitat',
        aggregationMethod: 'mean',
        singularUnits: {
            'en-us': 'leaf area index',
            'es-mx': 'índice de área foliar'
        },
        pluralUnits: {
            'en-us': 'leaf area index',
            'es-mx': 'índice de área foliar'
        },
        higherIsBetter: true
    },
    'effect-co2-reduction': {
        queryType: 'featureGeojson',
        queryLayer: 'carbon-footprint',
        attributes: ['totalemissions'],
        aggregationMethod: 'weightedAverage',
        singularUnits: {
            'en-us': 'ton of CO2 equivalent per year',
            'es-mx': 'tonelada de CO2 equivalente por año'
        },
        pluralUnits: {
            'en-us': 'tons of CO2 equivalent per year',
            'es-mx': 'toneladas de CO2 equivalente por año'
        }
    },
    'effect-community': {
        queryType: 'raster',
        includeBufferedArea: false,
        queryLayer: 'community-spaces-density',
        aggregationMethod: 'max',
        singularUnits: {
            'en-us': 'community space in 10-minute walkshed',
            'es-mx': 'espacio comunitario en un área de caminata de 10 minutos'
        },
        pluralUnits: {
            'en-us': 'community spaces in 10-minute walkshed',
            'es-mx': 'espacios comunitarios en un área de caminata de 10 minutos'
        },
        higherIsBetter: true
    },
    'effect-cooling': {
        queryType: 'raster',
        queryLayer: 'heatwave-temperature',
        aggregationMethod: 'mean',
        singularUnits: {
            'en-us': '°F average heatwave daytime high',
            'es-mx': 'promedio de temperatura máxima diurna de la ola de calor en °F'
        },
        pluralUnits: {
            'en-us': '°F average heatwave daytime high',
            'es-mx': 'promedio de temperatura máxima diurna de la ola de calor en °F'
        }
    },
    'effect-flood-safety': {
        queryType: 'raster',
        queryLayer: 'flood-risk',
        aggregationMethod: 'mean',
        singularUnits: {
            'en-us': 'meter flood depth (1% annual chance)',
            'es-mx': 'profundidad de inundación del medidor (1% de probabilidad anual)'
        },
        pluralUnits: {
            'en-us': 'meters flood depth (1% annual chance)',
            'es-mx': 'profundidad de inundación en metros (1% de probabilidad anual)'
        }
    },
    'effect-food': {
        queryType: 'featureGeojson',
        queryLayer: 'food-access',
        attributes: ['access'],
        aggregationMethod: 'valueOfMaxOverlap',
        singularUnits: {
            'en-us': 'food access',
            'es-mx': 'acceso a alimentos'
        },
        pluralUnits: {
            'en-us': 'food access',
            'es-mx': 'acceso a alimentos'
        },
        higherIsBetter: true
    },
    'effect-jobs': {
        queryType: 'featureGeojson',
        queryLayer: 'jobs',
        attributes: ['median_income'],
        aggregationMethod: 'weightedAverage',
        singularUnits: {
            'en-us': 'dollar per year median household income',
            'es-mx': 'ingreso medio de los hogares en dólares por año'
        },
        pluralUnits: {
            'en-us': 'dollars per year median household income',
            'es-mx': 'ingreso medio de los hogares en dólares por año'
        },
        higherIsBetter: true
    },
    'effect-mobility': {
        queryType: 'raster',
        queryLayer: 'transit-options',
        aggregationMethod: 'max',
        singularUnits: {
            'en-us': 'mobility option in 10-minute walkshed',
            'es-mx': 'opción de movilidad en un área de caminata de 10 minutos'
        },
        pluralUnits: {
            'en-us': 'mobility options in 10-minute walkshed',
            'es-mx': 'opciones de movilidad en un área de caminata de 10 minutos'
        },
        higherIsBetter: true
    },
    'effect-personal-health': {
        queryType: 'featureGeojson',
        queryLayer: 'life-expectancy',
        attributes: ['leb'],
        aggregationMethod: 'weightedAverage',
        singularUnits: {
            'en-us': 'year of life expectancy at birth',
            'es-mx': 'año de esperanza de vida al nacer'
        },
        pluralUnits: {
            'en-us': 'years of life expectancy at birth',
            'es-mx': 'años de esperanza de vida al nacer'
        },
        higherIsBetter: true
    },
    'effect-recreation': {
        queryType: 'raster',
        queryLayer: 'park-space-density',
        aggregationMethod: 'max',
        singularUnits: {
            'en-us': 'acre of green space in 10-minute walkshed',
            'es-mx': 'acre de espacio verde en un área de caminata de 10 minutos'
        },
        pluralUnits: {
            'en-us': 'acres of green space in 10-minute walkshed',
            'es-mx': 'acres de espacio verde en un área de caminata de 10 minutos'
        },
        higherIsBetter: true
    },
    'effect-soil-health': {
        queryType: 'raster',
        queryLayer: 'la-impervious-surface',
        aggregationMethod: 'categoricalPercentage',
        // returns a list, find categoricalPercentage.id === 20
        singularUnits: {
            'en-us': '% impervious surface',
            'es-mx': '% superficie impermeable'
        },
        pluralUnits: {
            'en-us': '% impervious surface',
            'es-mx': '% superficie impermeable'
        }
    },
    'effect-water-quality': {
        queryType: 'featureGeojson',
        queryLayer: 'water-pollutant-loading',
        attributes: ['pss_norm_areaweigh_pollloadng'],
        aggregationMethod: 'weightedAverage',
        singularUnits: {
            'en-us': 'normalized water pollutant loading score',
            'es-mx': 'puntuación de carga de contaminantes del agua normalizada'
        },
        pluralUnits: {
            'en-us': 'normalized water pollutant loading score',
            'es-mx': 'puntuación de carga de contaminantes del agua normalizada'
        }
    },
    'effect-water-supply': {
        queryType: 'raster',
        queryLayer: 'annual-rainfall',
        attributes: ['average_annual_precipitation'],
        aggregationMethod: 'volumeOverAreas',
        singularUnits: {
            'en-us': 'gallons of runoff per year',
            'es-mx': 'galón de escorrentía por año'
        },
        pluralUnits: {
            'en-us': 'gallons of runoff per year',
            'es-mx': 'galones de escorrentía por año'
        }
    }
};
// Use for binning if aggregationMethod == categoricalPercentage
export const percentBinning = {
    mapLayers: [
        {
            layerValues: [
                {
                    name: { 'en-us': 'Very Low' },
                    styleConfig: {
                        minValue: 0,
                        maxValue: 20
                    }
                },
                {
                    name: { 'en-us': 'Low' },
                    styleConfig: {
                        minValue: 20,
                        maxValue: 40
                    }
                },
                {
                    name: { 'en-us': 'Moderate' },
                    styleConfig: {
                        minValue: 40,
                        maxValue: 60
                    }
                },
                {
                    name: { 'en-us': 'High' },
                    styleConfig: {
                        minValue: 60,
                        maxValue: 80
                    }
                },
                {
                    name: { 'en-us': 'Very High' },
                    styleConfig: {
                        minValue: 80,
                        maxValue: 100
                    }
                }
            ]
        }
    ]
};
export const allSiteProfileSpecs = {
    ...conditionsTabProfile,
    ...detailsTabProfile,
    ...benefitsMetadata
};
/*
  To add to Sanity
*/
// On effect or layer pack?
// interface OnSomething {
//   opportunitySummary: IBaseProfileSpec
// }
// interface OnLayerValue {
//   // required for metric layer values only
//   opportunityRanking: TOpportunityRank
// }
// // New site profile one-off object?
// interface OnSomething {
//   conditionsTabProfile: Record<string, IBaseProfileSpec>
//   detailsTabProfile: Record<string, IBaseProfileSpec>
// }
//# sourceMappingURL=siteProfileSpecs.js.map